import React, { memo, useState } from 'react';
import { Sidebar } from './side-bar';
// import { Header } from './Header';
import { FileText } from 'lucide-react';

interface Props {
  children: JSX.Element | JSX.Element[];
  collapsed?: boolean;
  onCollapse?: () => void;
}

export const AdminLayout = memo((props: Props) => {
  return (
    <div className="flex bg-[#F2F4F8] w-full h-screen">
      {/* Sidebar always visible on the left */}
      <Sidebar />
      {/* Main content with header */}
      <div className="flex overflow-hidden flex-col flex-1 h-full">
        {/* <Header />
          <div className="flex-1 pt-[6.5rem]">
            <main className="h-[calc(100vh-6.5rem)] max-h-[57.5rem] p-6 pb-[4.625rem] overflow-y-auto">
              {props.children}
            </main>
          </div> */}
        {props.children}
      </div>
    </div>
  );
});
